import React, { useState } from "react";
import { Typography, Grid, CircularProgress } from "@mui/material";

// prettier-ignore
import "../dashboard/assets/css/bootstrap.min.css";
import "../dashboard/assets/css/icons.css";
import "../dashboard/assets/css/style.css";
import { getCurrencySymbol } from "../utils";
import AssignmentIcon from "@mui/icons-material/Assignment";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { Box } from "@mui/system";
import DashboardCard from "../components/DashboardCard";
import { useAtom } from "jotai";
import { dashboardInfoAtom } from "../atoms/atoms.js";

function DashBoardForm(props) {
    const [dashboardInfo] = useAtom(dashboardInfoAtom);
    const [loading] = useState(false);

    function getCurrentMonth() {
        let d = new Date();
        let month = new Array();
        month[0] = "January";
        month[1] = "February";
        month[2] = "March";
        month[3] = "April";
        month[4] = "May";
        month[5] = "June";
        month[6] = "July";
        month[7] = "August";
        month[8] = "September";
        month[9] = "October";
        month[10] = "November";
        month[11] = "December";
        return month[d.getMonth()];
    }

    function getCurrentYear() {
        let d = new Date();
        return d.getFullYear();
    }

    if (loading) {
        return (
            <Box
                sx={{
                    width: "100%",
                    height: "400px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                }}
            >
                <CircularProgress color="primary" />
            </Box>
        );
    } else {
        return (
            <>
                <Grid container spacing={10}>
                    <Grid item xs={10}>
                        <Typography
                            variant="h4"
                            sx={{
                                fontSize: "24px",
                                marginBottom: "10px"
                            }}
                            noWrap
                        >
                            Dashboard
                        </Typography>
                    </Grid>
                </Grid>

                {/* Dashboard Widget LIST BOX */}
                <Grid container spacing={2} sx={{ paddingTop: "20px" }}>
                    <Grid item lg={4} md={6} sm={6} xs={12}>
                        <DashboardCard
                            value={dashboardInfo?.sales_today || 0}
                            title="Sales Today"
                            icon={
                                <AssignmentIcon
                                    sx={{
                                        fontSize: "17px",
                                        color: "rgba(0,0,0,0.75)"
                                    }}
                                />
                            }
                            prefix={getCurrencySymbol()}
                        />
                    </Grid>
                    <Grid item lg={4} md={6} sm={6} xs={12}>
                        <DashboardCard
                            value={dashboardInfo?.sales_mtd || 0}
                            title={`${getCurrentMonth()} Sales`}
                            icon={
                                <AssignmentIcon
                                    sx={{
                                        fontSize: "17px",
                                        color: "rgba(0,0,0,0.75)"
                                    }}
                                />
                            }
                            prefix={getCurrencySymbol()}
                        />
                    </Grid>
                    <Grid item lg={4} md={6} sm={6} xs={12}>
                        <DashboardCard
                            value={dashboardInfo?.sales_ytd || 0}
                            title={`${getCurrentYear()} Sales`}
                            icon={
                                <AssignmentIcon
                                    sx={{
                                        fontSize: "17px",
                                        color: "rgba(0,0,0,0.75)"
                                    }}
                                />
                            }
                            prefix={getCurrencySymbol()}
                        />
                    </Grid>
                    <Grid item lg={4} md={6} sm={6} xs={12}>
                        <DashboardCard
                            value={dashboardInfo?.orders_today || 0}
                            title="Orders Today"
                            icon={
                                <ShoppingCartIcon
                                    sx={{
                                        fontSize: "17px",
                                        color: "rgba(0,0,0,0.75)"
                                    }}
                                />
                            }
                        />
                    </Grid>
                    <Grid item lg={4} md={6} sm={6} xs={12}>
                        <DashboardCard
                            value={dashboardInfo?.orders_mtd || 0}
                            title={`${getCurrentMonth()} Orders`}
                            icon={
                                <ShoppingCartIcon
                                    sx={{
                                        fontSize: "17px",
                                        color: "rgba(0,0,0,0.75)"
                                    }}
                                />
                            }
                        />
                    </Grid>
                    <Grid item lg={4} md={6} sm={6} xs={12}>
                        <DashboardCard
                            value={dashboardInfo?.orders_ytd || 0}
                            title={`${getCurrentYear()} Orders`}
                            icon={
                                <ShoppingCartIcon
                                    sx={{
                                        fontSize: "17px",
                                        color: "rgba(0,0,0,0.75)"
                                    }}
                                />
                            }
                        />
                    </Grid>
                </Grid>
            </>
        );
    }
}

export default DashBoardForm;
